import { isPhoneLengthValid } from '../../utils';

import type { Country, PhoneLengthError } from '../../../model';

/** Возвращает ключ ошибки, если цифры введены, но их количество вне допустимого диапазона */
export const getPhoneLengthError = (digitsLength: number, country: Country): PhoneLengthError | null => {
  if (digitsLength === 0 || isPhoneLengthValid(digitsLength, country)) {
    return null;
  }

  return digitsLength < country.minLength ? 'minLength' : 'invalidFormat';
};
